'use client';

import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { addressesRegistry, ChainId, type PeripheralBalanceType, type Token } from '@morpho-org/blue-sdk';
import { ExternalLink } from '@morpho-org/ui-v6/server';
import { Button, Popover, PopoverAnchor, PopoverContent, Switch } from '@repo/ui';
import { useCallback, useMemo, useState } from 'react';
export interface SwitchPeripheralSourcesProps {
  isDisabled?: boolean;
  peripheralBalanceType: PeripheralBalanceType;
  active: boolean;
  ctaAction: (isActive: boolean) => void;
  srcToken: Token;
  baseToken: InterfaceToken | null | undefined;
}
const SwitchPeripheralSources = t0 => {
  const $ = _c(35);
  const {
    isDisabled,
    peripheralBalanceType,
    active,
    ctaAction,
    srcToken,
    baseToken
  } = t0;
  const [isOpenPopover, setIsOpenPopover] = useState(false);
  baseToken?.address;
  baseToken?.symbol;
  let t1;
  bb0: switch (peripheralBalanceType) {
    case "vault":
    case "wrapped-vault":
    case "staked-wrapped":
    case "unwrapped-staked-wrapped":
    case "wrapped":
      {
        const t2 = baseToken?.symbol;
        let t3;
        if ($[0] !== baseToken?.address) {
          t3 = baseToken?.address === addressesRegistry[ChainId.EthMainnet].wstEth && <ExternalLink href="https://docs.lido.fi/#liquid-staking" underlined={true}>Learn more about liquid staking here →</ExternalLink>;
          $[0] = baseToken?.address;
          $[1] = t3;
        } else {
          t3 = $[1];
        }
        let t4;
        if ($[2] !== srcToken.symbol || $[3] !== t2 || $[4] !== t3) {
          t4 = <>Supply {srcToken.symbol} and the Bundler contract will automatically wrap it into{" "}{t2}.{" "}{t3}</>;
          $[2] = srcToken.symbol;
          $[3] = t2;
          $[4] = t3;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        t1 = t4;
        break bb0;
      }
    case "base":
      {
        t1 = null;
        break bb0;
      }
    default:
      {
        t1 = null;
      }
  }
  const body = t1;
  let t2;
  if ($[6] !== active || $[7] !== body || $[8] !== ctaAction) {
    t2 = isActive => {
      if (!active && body) {
        setIsOpenPopover(true);
      } else {
        ctaAction(isActive);
      }
    };
    $[6] = active;
    $[7] = body;
    $[8] = ctaAction;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const switchClick = t2;
  const t3 = `peripheral-token-switch-${peripheralBalanceType}`;
  let t4;
  if ($[10] !== active || $[11] !== isDisabled || $[12] !== switchClick || $[13] !== t3) {
    t4 = <PopoverAnchor asChild={true}><Switch checked={active} onCheckedChange={switchClick} disabled={isDisabled} data-testid={t3} /></PopoverAnchor>;
    $[10] = active;
    $[11] = isDisabled;
    $[12] = switchClick;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = baseToken?.symbol;
  let t6;
  if ($[15] !== srcToken.symbol || $[16] !== t5) {
    t6 = <div className="gap-2xs flex flex-row items-center"><span className="text-md leading-none">{t5} / {srcToken.symbol}</span></div>;
    $[15] = srcToken.symbol;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== body) {
    t7 = <span className="text-2xs text-center">{body}</span>;
    $[18] = body;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div className="gap-sm flex flex-col items-center">{t6}{t7}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== ctaAction) {
    t9 = <Button onClick={() => {
      ctaAction(true);
      setIsOpenPopover(false);
    }}>I understand</Button>;
    $[23] = ctaAction;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Button variant="ghost" onClick={() => setIsOpenPopover(false)}>Cancel</Button>;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t9) {
    t11 = <div className="gap-xs flex flex-col">{t9}{t10}</div>;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t8) {
    t12 = <PopoverContent side="top" sideOffset={8} className="p-md rounded-lg"><div className="gap-lg flex flex-col" data-testid="peripheral-sources-warning">{t8}{t11}</div></PopoverContent>;
    $[28] = t11;
    $[29] = t8;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== isOpenPopover || $[32] !== t12 || $[33] !== t4) {
    t13 = <Popover open={isOpenPopover} onOpenChange={setIsOpenPopover}>{t4}{t12}</Popover>;
    $[31] = isOpenPopover;
    $[32] = t12;
    $[33] = t4;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};
export default SwitchPeripheralSources;